import { Button, Tooltip, styled } from '@mui/material';
import type { ButtonProps } from '@mui/material/Button';

const UserActionBtn = styled(Button)({
  minHeight: '29px',
  paddingTop: 0,
  paddingBottom: 0,
  borderRadius: '32px',
  textWrap: 'nowrap',
});

interface IProps extends ButtonProps {
  tooltip?: string;
}

const TableActionButton = ({ tooltip, ...props }: IProps) => {
  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        <UserActionBtn {...props} />
      </Tooltip>
    );
  }

  return <UserActionBtn {...props} />;
};

export default TableActionButton;
